module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-goods-list",
    on: {
      "click": _vm.onClickGoods
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_vm._t("flag"), _vm._v(" "), _c('img', {
    staticClass: "goods-img ui-imglazyload",
    attrs: {
      "src": "//cdn.upin.com/mfanhuan/images/home/brand_Return/brand_return_load_alpha_368.png?v=20160216",
      "alt": _vm.goods.Title,
      "data-src": _vm.goods.ImagUrl
    }
  }), _vm._v(" "), (_vm.goods.solded) ? _c('i', {
    staticClass: "icon-solded"
  }, [_vm._v("抢光啦")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.goods.MallName))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.goods.Title))])]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    class: {
      'multiple': _vm.goods.type === 'chaogao' || _vm.goods.type === 'lingquan'
    }
  }, [_c('div', {
    staticClass: "now-price"
  }, [_c('span', {
    staticClass: "rmb"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "integer"
  }, [_vm._v(_vm._s(_vm.goods.integer))]), _vm._v(" "), _c('span', {
    staticClass: "float"
  }, [_vm._v(_vm._s(_vm.goods.float))])]), _vm._v(" "), ((_vm.goods.type === 'zhekou' || _vm.goods.type === 'fanhuan') && _vm.goods.NowPrice != _vm.goods.OldPrice) ? _c('div', {
    staticClass: "origin-price"
  }, [_vm._v(_vm._s(_vm.goods.OldPrice))]) : _vm._e(), _vm._v(" "), (_vm.goods.type === 'chaogao') ? _c('div', {
    staticClass: "origin-price"
  }, [_c('span', {
    staticClass: "before-price"
  }, [_vm._v("支付" + _vm._s(_vm.goods.NowPrice))]), _vm._v(" "), _c('span', {
    staticClass: "discount"
  }, [_vm._v("返还" + _vm._s(_vm.goods.ReturnPrice))])]) : _vm._e(), _vm._v(" "), (_vm.goods.type === 'lingquan') ? _c('div', {
    staticClass: "origin-price"
  }, [_c('span', {
    staticClass: "before-price"
  }, [_vm._v("支付" + _vm._s(_vm.goods.NowPrice))]), _vm._v(" "), _c('span', {
    staticClass: "discount"
  }, [_vm._v("领券减" + _vm._s(_vm.goods.ReturnPrice))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "oprate"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('span', {
    staticClass: "loading",
    style: ({
      width: _vm.goods.HasSaleRate + '%'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("已抢" + _vm._s(_vm.goods.HasSaleRate) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: _vm.goods.solded ? 'gray' : 'red'
  }, [_vm._v(_vm._s(_vm.goods.btnText))])]), _vm._v(" "), (_vm.goods.HasSaleNum) ? _c('div', {
    staticClass: "sale-amount",
    class: _vm.goods.solded ? 'gray' : ''
  }, [_vm._v(_vm._s(_vm.goods.HasSaleNum) + "人抢购")]) : _vm._e()])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-49b7a1fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-49b7a1fc!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/goods/goods-list.vue
// module id = 34
// module chunks = 0